import { gsap } from "gsap";
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

const modalTriggers = document.querySelectorAll('[data-modal]')

const modalAnimType = (modalId) => {
    const tl = gsap.timeline({ paused: true })
    const title = document.querySelector(`#${modalId} .modal__title div`)

    if (!title) return tl

    tl
        .fromTo(`#${modalId} .modal__title div, #${modalId} .modal__desc div`, {
            yPercent: 100,
        },{
            yPercent: 0,
            duration: .9,
            stagger: 0.15,
            ease: 'power1.out'
        }, 0)
        .fromTo(`#${modalId} .modal__form > div`, {
            y: 16,
            autoAlpha: 0
        },{
            y: 0,
            autoAlpha: 1,
            duration: .7,
            stagger: .08,
            ease: 'power1.out'
        }, .35)

    return tl
}

modalTriggers.forEach(item => {
    const modalId = item.dataset.modal;
    const modal = document.querySelector(`#${modalId}`);
    // const loopObj = false

    if (!modal) return

    const modalCloseButtons = modal.querySelectorAll('.js-modal-close')
    const modalWrapper = modal.querySelector('.modal-container__wrapper')
    let activeTrigger = null

    const initAnimation = gsap.timeline({ paused: true });

    const animation = modalAnimType(modalId)

    initAnimation
        .fromTo(modal.querySelector('.modal'), {
            y: 16,
            scaleX: .95,
            autoAlpha: 0,
        }, {
            y: 0,
            scaleX: 1,
            autoAlpha: 1,
            // duration: .5,
            ease: 'power1.inOut'
        }, 0)
        .fromTo(modal.querySelector('.modal-container__overlay'), {
            autoAlpha: 0,
        }, {
            autoAlpha: 1,
            // duration: .5,
            ease: 'power1.inOut'
        }, 0)

    const keyDownClose = (e) => {
        if (e.key === 'Escape') {
            // eslint-disable-next-line no-use-before-define
            setInactive()
        }
    }

    const wrapperClickCheck = (e) => {
        if (e.target === modalWrapper) {
            // eslint-disable-next-line no-use-before-define
            setInactive()
        }
    }

    const setInactive = (event) => {
        event?.preventDefault()

        initAnimation.timeScale(1.5).reverse().then(() => {
            modal.classList.remove('is-active')
            modal.setAttribute('aria-hidden', 'true')
            enableBodyScroll(modal);

            modalCloseButtons.forEach(closeButton => {
                closeButton.removeEventListener('click', setInactive)
            })
            modalWrapper.removeEventListener('click', wrapperClickCheck)
            window.removeEventListener('keydown', keyDownClose)

            activeTrigger?.focus()
            activeTrigger = null

            animation.kill()
        })
    }

    const setActive = () => {
        activeTrigger = item
        disableBodyScroll(modal, {
            reserveScrollBarGap: true,
        });
        modal.classList.add('is-active')
        modal.setAttribute('aria-hidden', 'false')
        document.querySelector('.header').classList.remove('is-visible');

        modalCloseButtons.forEach(closeButton => {
            closeButton.addEventListener('click', setInactive)
        })

        modalWrapper.addEventListener('click', wrapperClickCheck)

        window.addEventListener('keydown', keyDownClose)

        initAnimation.timeScale(1).progress(0).play().then(() => {
            const firstFocusableElement = modal.querySelector(
                '.modal__close, button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
            )

            firstFocusableElement?.focus()
        })
        animation.restart()
    }

    item.addEventListener('click', (e) => {
        e.preventDefault()

        setActive()
    })
})


// открытие видео в модалке по клику

const modalVideo = document.getElementById('modal-video');

// контент модалки
const modalVideoBody = modalVideo?.querySelector('[data-video-modal-body]');
const modalVideoTitle = modalVideo?.querySelector('[data-video-modal-title]');
const defaultVideoModalTitle = modalVideoTitle?.textContent?.trim() || 'Video player';
const videoModalCleanupDelay = 200;

const clearVideoModal = () => {
    if (modalVideoBody) modalVideoBody.innerHTML = '';
    if (modalVideoTitle) modalVideoTitle.textContent = defaultVideoModalTitle;
};

const renderVideoToModal = (type, src, title = defaultVideoModalTitle) => {
    if (!modalVideoBody) return;

    clearVideoModal();
    if (modalVideoTitle) modalVideoTitle.textContent = title || defaultVideoModalTitle;

    if (type === 'file') {
        const video = document.createElement('video');
        video.controls = true;
        video.autoplay = true;
        video.playsInline = true;
        video.style.width = '100%';
        video.setAttribute('aria-label', title || defaultVideoModalTitle);

        const source = document.createElement('source');
        source.src = src;
        source.type = 'video/mp4';

        video.appendChild(source);
        modalVideoBody.appendChild(video);
        return;
    }

    if (type === 'rutube') {
        const iframe = document.createElement('iframe');
        iframe.src = `https://rutube.ru/play/embed/${src}?autoplay=1`;
        iframe.title = title || defaultVideoModalTitle;
        iframe.allowFullscreen = true;
        iframe.setAttribute('allow', 'autoplay; encrypted-media; gyroscope; picture-in-picture');
        iframe.className = 'video-frame';

        modalVideoBody.appendChild(iframe);
    }
};

// Подстановка ДО открытия
document.addEventListener('click', (e) => {
    const trigger = e.target.closest('[data-video-trigger][data-modal="modal-video"]');
    if (!trigger) return;

    const type = trigger.dataset.videoType;
    const src = trigger.dataset.videoSrc;
    const title = trigger.dataset.videoTitle?.trim() || defaultVideoModalTitle;

    if (!type || !src) {
        e.preventDefault();
        e.stopPropagation();
        return;
    }

    renderVideoToModal(type, src, title);
}, true);

//  Очистка при закрытии
if (modalVideo) {
    modalVideo.querySelectorAll('.js-modal-close').forEach((btn) => {
        btn.addEventListener('click', () => setTimeout(clearVideoModal, videoModalCleanupDelay));
    });

    const wrapper = modalVideo.querySelector('.modal-container__wrapper');
    wrapper?.addEventListener('click', (e) => {
        if (e.target === wrapper) setTimeout(clearVideoModal, videoModalCleanupDelay);
    });

    window.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && modalVideo.classList.contains('is-active')) {
            setTimeout(clearVideoModal, videoModalCleanupDelay);
        }
    });
}
